import axios from "axios";
import { API_BASE_URI } from "../../../redux/ApiCall";
import { User } from "../../../redux/User/User.type";
import { Document } from "../../../redux/Document/Document.type";
import { ApiCallState } from "../../../redux/Utils";

export type UserComponentPropType = {
  fetchUser: Function;
  user: ApiCallState<User>;
  form: any;
  setIsModalVisible: Function;
  setLoading: Function;
  loading: boolean;
  fetchDocument: Function;
  document: ApiCallState<Document>;
};

export const sendUserOnlyData = (data: any) =>
  axios.put(`${API_BASE_URI}/user`, data);

export const sendUserSignature = (data: any) =>
  axios.put(`${API_BASE_URI}/user`, data, {
    headers: {
      "Content-type": "multipart/form-data",
    },
  });

export const removeData = (id: any) =>
  axios.delete(`${API_BASE_URI}/signature/${id}`);

export const changePassword = (data: { password: string }) =>
  axios.put(`${API_BASE_URI}/user/change-password`, data);
